import Renderer from "@wielink/datatables/Renderers/Renderer";

class ReorderRenderer extends Renderer {
    render() {
        if (this.type == 'display') {
            return '<i class="bi bi-arrows-move" style="font-size: 1.2em;line-height:1;"></i>';
        }
        return this.data;
    }
}

export default ReorderRenderer;